<div class="min-h-48 flex items-center justify-center px-4">
  
  <div class="max-w-md w-full bg-white p-8 rounded-lg shadow-md">
    
    <h2 class="text-2xl font-bold text-center text-gray-800 mb-8">
      Autenticación
    </h2>
    
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-6">
      
      <div>
        <label for="username" class="block text-sm font-medium text-gray-700 mb-1">
          Usuario
        </label>
        <input 
          id="username" 
          type="text" 
          formControlName="username" 
          class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-150 ease-in-out"
          [ngClass]="{'border-red-500 focus:ring-red-500': loginForm.get('username')?.touched && loginForm.get('username')?.invalid}"
          placeholder="username"
        >
        <p *ngIf="loginForm.get('username')?.touched && loginForm.get('username')?.invalid" class="mt-1 text-sm text-red-600">
          El usuario es obligatorio
        </p>
      </div>

      <div>
        <label for="password" class="block text-sm font-medium text-gray-700 mb-1">
          Contraseña
        </label>
        <input 
          id="password" 
          type="password" 
          formControlName="password"
          class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-150 ease-in-out"
          [ngClass]="{'border-red-500 focus:ring-red-500': loginForm.get('password')?.touched && loginForm.get('password')?.invalid}"
          placeholder="••••••••"
        >
        <p *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid" class="mt-1 text-sm text-red-600">
          La contraseña es obligatoria
        </p>
      </div>

      <div *ngIf="loginError" class="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
        <div class="flex">
          <div class="ml-3">
            <p class="text-sm text-red-700 font-medium">
              {{ loginError }}
            </p>
          </div>
        </div>
      </div>

      <div>
        <button 
          type="submit" 
          [disabled]="loginForm.invalid"
          class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-400 disabled:cursor-not-allowed transition duration-150"
        >
          Entrar
        </button>
      </div>
    </form>
    
  </div>
</div>